export default __webpack_public_path__ + "static/media/check-icon.d52d8a9a.svg";